import {
  Sekcja,
  Zdjecie,
  Paragraf,
  Naglowek,
  Artykul,
  Podtytul,
  Numer,
  Tytul,
  Opis,
  StepButton,
  StepArrow,
} from "./styled";
import { useState } from "react";
import sekcja3 from "../../../images/sekcja-3-zdjecie.webp";
import sekcja3Mobile from "../../../images/sekcja-3-zdjecie-mobile.webp";
import { zysk } from "./zysk";

const CoZyskasz = () => {
  const [openStep, setOpenStep] = useState(null);
  return (
    <Sekcja id="jak-pomagamy">
      <Zdjecie
        src={sekcja3}
        srcSet={`${sekcja3Mobile} 767w, ${sekcja3} 846w`}
        sizes="(max-width: 767px) 100vw, 45vw"
        alt="Justyna i Paweł analizują dokumenty klienta"
        width="846"
        height="971"
        loading="lazy"
        decoding="async"
      />
      <div>
        <Tytul><span>Jak wygląda współpraca?</span>Jak pomożemy Ci przejść przez finansowanie?</Tytul>
        <Artykul>
          {zysk.map(({ numer, tytul, artykul }, index) => (
            <Paragraf key={numer} $open={openStep === index}>
              <Numer> {numer} </Numer>
              <Naglowek>
                <StepButton type="button" aria-expanded={openStep === index} onClick={() => setOpenStep(openStep === index ? null : index)}>
                  <Podtytul> {tytul} </Podtytul><StepArrow aria-hidden="true">{openStep === index ? "−" : "+"}</StepArrow>
                </StepButton>
                <Opis $open={openStep === index}> {artykul} </Opis>
              </Naglowek>
            </Paragraf>
          ))}
        </Artykul>
      </div>
    </Sekcja>
  );
};

export default CoZyskasz;

